import React from 'react';
import { Header_data } from '../constant';
import { FacebookIcon, EmailIcon, EmailShareButton, LinkedinIcon, RedditIcon, WhatsappIcon, WhatsappShareButton } from "react-share";
import { Card } from '@material-ui/core';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Header(){
    return (
        <div className="row load1">
            <div className="col-sm-9">
                <h1>{Header_data.heading.name}</h1>
                {Header_data.heading.sub_text}
                <div className="row">
                    <div className="col-sm-1"><EmailShareButton url="yashdatir@gmail.com"><EmailIcon /></EmailShareButton></div>
                    <div className="col-sm-1"><a target="blank" href="https://www.facebook.com/yash.datir"><FacebookIcon/></a></div>
                    <div className="col-sm-1"><a target="blank" href="https://www.linkedin.com/in/yash-datir-a99237121/"><LinkedinIcon /></a></div>
                    <div className="col-sm-1"><a target="blank" href="https://www.reddit.com/user/YashDatir310898"><RedditIcon /></a></div>
                </div>
                <div className="row">
                <div className="col-sm-1">
                    <WhatsappShareButton url="7990097420" title="Hi Yash"><WhatsappIcon /></WhatsappShareButton>
                    <div style={{background:'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)', width:'64px', margin:'0', padding:'0'}}>
                    <a target="blank" href='https://www.instagram.com/yashdatir/'>
                        <i style={{marginLeft:'2px'}} className="fab fa-instagram fa-5x"></i>
                    </a>
                    </div>
                    <div>
                    <a target="blank" href='https://github.com/yashdatir'>
                        <i style={{margin:'3px'}} className="fab fa-github fa-4x"></i>
                    </a>
                    </div>
                </div>
                <div className="col-sm-11">
                <img 
                    width={Header_data.image.style.width}
                    height={Header_data.image.style.height}  
                    alt={Header_data.image.alt} 
                    src={Header_data.image.src} 
                />
                </div>
                </div>
                <div className="row">
                    <div className="col-sm-1">
                    <div style={{width:'64px', margin:'0', padding:'0'}}>
                    <a target="blank" href='https://stackoverflow.com/users/8276785/yash-datir'>
                        <i className="fa fa-stack-overflow fa-4x" aria-hidden="true"></i>
                    </a>
                    </div>
                    </div>
                    <div className="col-sm-1">
                    <div style={{width:'64px', margin:'0', padding:'0'}}>
                    <a target="blank" href='https://www.twitch.tv/yashdatir'>
                        <i className="fa fa-twitch fa-4x" aria-hidden="true"></i>
                    </a>
                    </div>
                    </div>
                    <div className="col-sm-1">
                    <div style={{width:'64px', margin:'0', padding:'0'}}>
                    <a target="blank" href='https://twitter.com/866aacf9d6734ad'>
                        <i className="fa fa-twitter-square fa-4x" aria-hidden="true"></i>
                    </a>
                    </div>
                    </div>
                    <div className="col-sm-1">
                    <div style={{width:'64px', margin:'0', padding:'0'}}>
                    <a target="blank" href='https://www.youtube.com/user/yashdatir'>
                        <i className="fa fa-youtube-play fa-4x" aria-hidden="true"></i>
                    </a>
                    </div>
                    </div>
                </div>
            </div>
                <div style={{marginLeft:'-45%', marginTop:'2%'}} className="col-sm-8">
                    <div style={{backgroundColor:'#e6e6e6', padding:'15px'}} className="row">
                        <h3><i className="fa fa-trophy" aria-hidden="true"></i>{'  '+Header_data.card.heading}</h3>
                        <OwlCarousel margin={10} items={3.5} loop autoplay>
                        {
                            Header_data.card.data.map((data, i)=>(
                                <div key={i} style={{height:'285px'}} className="col-sm-4">
                                    <Card style={data.style}>
                                        <center><h3>{data.info.heading}</h3>
                                        <p style={{height:'130px', width:'170px', textOverflow:'hidden', textAlign:'justify'}}>{data.info.body}</p></center>
                                        <a style={{float:'right',margin:'5px'}} href={data.info.link}>Read More</a>
                                    </Card>
                                </div>
                            ))
                        }
                        </OwlCarousel>
                    </div>
                </div>
            </div>
    )
}

export default Header;